import axios from 'axios'
import React, { useEffect, useState } from 'react'

const ViewEnquiries = () => {
    const [enquiries,setEnq] = useState([])

    const[name, setName] = useState('');
    const[mobile, setMobile] = useState('');
    const[email, setEmail] = useState('');
    const[message, setMessage] = useState('');
    const[_id, setId] = useState('');

    // ✅ FIXED: Added dependency array (runs only once)
    useEffect(()=>{
        axios.get('https://ezer-eventapp.onrender.com/enquiries')
        .then((res)=>setEnq(res.data))
        .catch((err)=>console.log(err))
    }, [])
    
    const deleteEnq = (enqId) => {
        axios.delete(`https://ezer-eventapp.onrender.com/enquiries/${enqId}`)
        .then((res)=>{alert("Enquiry deleted successfully")})
        .catch((err)=>console.log(err))
    }

    const getOneRecord = (enqId) => {
        axios.get(`https://ezer-eventapp.onrender.com/enquiries/${enqId}`)
        .then((res)=>{
            setName(res.data.name);
            setMobile(res.data.mobile);
            setEmail(res.data.email);
            setMessage(res.data.message);
            setId(res.data._id);
        })
        .catch((err)=>console.log(err))
    }

    const updateEnq = (e) => {
        e.preventDefault();
        axios.put(`https://ezer-eventapp.onrender.com/${_id}`, {_id, name, mobile, email, message})
        .then((res)=>alert("Enquiry updated successfully"))
        .catch((err)=>console.log(err))
    }

  return (
    <div className='container mt-5'>
        <h1 className='text-center mb-5'>ViewEnquiry</h1>

        <table className="table table-bordered table-hover m-2">
            <thead className="table-dark text-center">
                <tr>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    <th>Message</th>
                    {/* <th>Action</th> */}
                </tr>
            </thead>

            <tbody>
                {
                    // ✅ NEW: Reverse to show latest first
                    [...enquiries].reverse().map((enq,index)=>{
                        return(
                            <tr key={index}>
                                <td>{enq.name}</td>
                                <td>{enq.mobile}</td>
                                <td>{enq.email}</td>
                                <td>{enq.message}</td>
                                {/* <td>
                                    <button 
                                      onClick={()=>getOneRecord(enq._id)} 
                                      data-bs-toggle='modal' 
                                      data-bs-target='#update' 
                                      className='btn btn-primary me-2'
                                    >
                                      Edit
                                    </button>

                                    <button 
                                      onClick={()=>deleteEnq(enq._id)} 
                                      className='btn btn-danger'
                                    >
                                      Delete
                                    </button>
                                </td> */}
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>

        {/* MODAL */}
        <div className='modal' id='update'>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className='modal-header'>
                        <h5 className='modal-title'>Edit Enquiry</h5>
                        <button type='button' className='btn-close' data-bs-dismiss='modal'></button>
                    </div>

                    <div className='modal-body'>
                        <form onSubmit={updateEnq}>
                            <input 
                              onChange={(e) => setName(e.target.value)} 
                              name="name" 
                              className='form-control mb-3' 
                              placeholder='Enter your name' 
                              value={name} 
                            />

                            <input 
                              onChange={(e) => setMobile(e.target.value)} 
                              name="mobile" 
                              className='form-control mb-3' 
                              placeholder='Enter your mobile number' 
                              value={mobile} 
                            />

                            <input 
                              onChange={(e) => setEmail(e.target.value)} 
                              type="email" 
                              className='form-control mb-3' 
                              placeholder='Enter your email' 
                              value={email} 
                            />

                            <input 
                              onChange={(e) => setMessage(e.target.value)} 
                              type="message" 
                              className='form-control mb-3' 
                              placeholder='Enter your message' 
                              value={message} 
                            />

                            <input type="submit" className='form-control' />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ViewEnquiries